import { useContext, useEffect, useRef, useState } from "react";
import Eventos from "../../page/eventos/Eventos";
import { useNavigate, useParams, useLocation } from "react-router-dom";
//import { format } from "date-fns";
//import apiAntesala from "../../../config/ConfigPublic";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { authContext } from "../../../../context/auth/AuthContext";
import axios from "axios";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";
import { format } from "date-fns";
import { filter } from "framer-motion/client";

const EventosController = () => {
  const { search } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(authContext);
  const { data } = user;
  const [filter, setFilter] = useState({
    //["filter[provincia]"]: "Córdoba",
    status: 1,
    ["filter[fecha]"]: format(new Date(), "yyyy-MM-dd").toString(), //FullMonth(new Date()),
    sort: "fechas.fecha",
    per_page: 15,
  });
  const [salas, setSalas] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [categorias, setCategorias] = useState(null);
  const [eventos, setEventos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [anterior, setAnterior] = useState(false);
  const controllerRef = useRef(null);

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "status":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("id", value.evento.id);

          /*Evento*/
          formData.append("status_id", value.status);

          const response = await RestPrivateAntesala({
            url: `/eventos/${value.evento.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.status == 201 || response.status == 200) {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "401",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "añadir-evento":
        {
          return (window.location.href = "/dashboard/eventos/nuevo");
        }
        break;
      case "editar-evento":
        {
          return (window.location.href = "/dashboard/eventos/" + value);
        }
        break;
      case "exportar-excel":
        {
          // La lógica de exportación se maneja en el componente FiltroEventos
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controllerRef.current) controllerRef.current.abort();

          controllerRef.current = new AbortController();
          const signal = controllerRef.current.signal;

          let params = {
            ...filter,
            ["filter[nombre]"]: e.target.value,
          };

          setLoading(true);
          setFilter({ ...params });

          return fetch(setEventos, params, "/eventos", signal, setLoading);
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal, loading) => {
    try {
      const response = await apiPrivateAntesala.get(url, {
        params,
        signal,
      });
      if (response.status == 201 || response.status == 200) {
        setData(response.data);
        setLoading(false);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        //console.log("Request aborted");
      } else {
        //console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (!eventos) {
      setLoading(true);
      let params = {
        ...filter,
      };

      if (search) {
        params = {
          ...filter,
          ["filter[nombre]"]: search,
        };

        setFilter({ ...params });
      }

      // Verificar si existe el query param permiso=1
      const urlParams = new URLSearchParams(location.search);
      if (urlParams.get('permiso') === '1') {
        params = {
          ...params,
          permiso: 1,
        };
        setFilter({ ...params });
      }

      fetch(setEventos, params, "/eventos", null, setLoading);
    }
  }, []);

  useEffect(() => {
    if (!salas) {
      fetch(setSalas, { ["filter[provincia]"]: "Córdoba" }, "/salas");
    }
  }, []);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  useEffect(() => {
    if (!categorias) {
      fetch(setCategorias, {}, "/categorias");
    }
  }, []);

  
  return (
    <Eventos
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      salas={salas ?? { data: [] }}
      provincias={provincias ?? []}
      categorias={categorias ?? []}
      data={eventos ?? { data: [], links: [] }}
      loading={loading}
      setLoading={setLoading}
      setData={setEventos}
      onChange={onChange}
      onClick={onClick}
      setSalas={setSalas}
      navigate={navigate}
      user={user.data}
      setAnterior={setAnterior}
      anterior={anterior}
    />
  );
};

export default EventosController;
